export const TRACKED_PAGES = {
  FIRST_CLASS_BOOKED: 'First class booked',
  FIRST_CLASS_COMPLETED: 'First class completed',
  FREE_CLASS_COMPLETED: 'Free class completed',
  COURSE_PURCHASED: 'Course purchased',
}

export const FB_EVENTS = {
  SIGNUP_COMPLETED: 'SignupCompleted',
  // Fired when a parent declares purchase intent in the trial booking
  // qualifier. The answer is passed as `intent` metadata; a Meta Custom
  // Conversion filters on `intent = high` so the campaign can optimize toward
  // intent rather than free-trial bookings. See the qualifier experiment.
  TRIAL_PURCHASE_INTENT_DECLARED: 'TrialPurchaseIntentDeclared',
  FIRST_CLASS_BOOKED: 'FirstClassBooked',
  FIRST_CLASS_BOOKED_MATH: 'FirstClassBookedMath',
  FIRST_CLASS_BOOKED_ELA: 'FirstClassBookedELA',
  // Indian-ethnicity (NRI) counterparts. These fire *alongside* the primary
  // event above, and are themselves split by subject: an Indian-ethnicity Math
  // booking reports FirstClassBookedMathIndianNRI, never the plain
  // FirstClassBookedIndianNRI. Resolved via `@lib/utils/trial-events`.
  FIRST_CLASS_BOOKED_INDIAN_NRI: 'FirstClassBookedIndianNRI',
  FIRST_CLASS_BOOKED_MATH_INDIAN_NRI: 'FirstClassBookedMathIndianNRI',
  FIRST_CLASS_BOOKED_ELA_INDIAN_NRI: 'FirstClassBookedELAIndianNRI',
  FIRST_CLASS_COMPLETED: 'FirstClassCompleted',
  FREE_CLASS_JOIN: 'FreeClassJoin',
  FREE_CLASS_JOIN_MATH: 'FreeClassJoinMath',
  FREE_CLASS_JOIN_ELA: 'FreeClassJoinELA',
  FREE_CLASS_JOIN_INDIAN_NRI: 'FreeClassJoinIndianNRI',
  FREE_CLASS_JOIN_MATH_INDIAN_NRI: 'FreeClassJoinMathIndianNRI',
  FREE_CLASS_JOIN_ELA_INDIAN_NRI: 'FreeClassJoinELAIndianNRI',
  FREE_CLASS_COMPLETED: 'FreeClassCompleted',
  FREE_CLASS_COMPLETED_MATH: 'FreeClassCompletedMath',
  FREE_CLASS_COMPLETED_ELA: 'FreeClassCompletedELA',
  FREE_CLASS_COMPLETED_INDIAN_NRI: 'FreeClassCompletedIndianNRI',
  FREE_CLASS_COMPLETED_MATH_INDIAN_NRI: 'FreeClassCompletedMathIndianNRI',
  FREE_CLASS_COMPLETED_ELA_INDIAN_NRI: 'FreeClassCompletedELAIndianNRI',
  // Course-purchase events are split by subject. The unsuffixed name means
  // Coding, and is also the fallback for any unknown or missing subject.
  // Exactly one of the three fires per purchase - never the generic one
  // alongside a subject variant.
  COURSE_PURCHASED: 'CoursePurchased',
  COURSE_PURCHASED_MATH: 'CoursePurchasedMath',
  COURSE_PURCHASED_ELA: 'CoursePurchasedELA',
  NCO_HACKATHON_REGISTRATION_COMPLETED: 'NCOHackathonRegistrationCompleted',
  HPE_CODEBATTLE_REGISTRATION_COMPLETED: 'HpeCodeBattleRegistrationCompleted',
  TEACHER_PROFILE_COMPLETED: 'TeacherProfileCompleted',
  TEACHER_APPLICATION_COMPLETED: 'TeacherApplicationCompleted',
}

export const TRACKED_ONBOARDING_FLOWS = {
  GAMIFICATION: 'Gamification onboarding modal state',
  DASHBOARD_INTRODUCTION: 'Onboarding intro of dashboard state',
  TEACHER_CALENDAR_TOUR_STATE: 'Teacher calendar product tour state',
  TEACHER_CLASSROOM_TOUR_STATE: 'Teacher classroom product tour state',
}
